import { nanoid } from 'nanoid';
import { create } from 'zustand';

import { ISnackbarItem, SnackbarType, ISnackbarState } from './types';

const closeTimeouts: { [key: string]: NodeJS.Timeout } = {};

const TIMEOUT = 7000;

const snackbarStore = create<ISnackbarState>()((set, get) => ({
  snackItems: [] as ISnackbarItem[],

  snackbarClose: (id: string) => {
    if (closeTimeouts[id]) {
      clearTimeout(closeTimeouts[id]);
      delete closeTimeouts[id];

      set((state) => ({
        snackItems: state.snackItems.filter((item) => item.id !== id),
      }));
    }
  },

  snackbarShow: (item) => {
    const id = nanoid(4);

    set((state) => ({ snackItems: [{ id, ...item }, ...state.snackItems] }));
    closeTimeouts[id] = setTimeout(() => {
      get().snackbarClose(id);
    }, TIMEOUT);

    return id;
  },

  snackbarShowSuccess: (children: string) => {
    return get().snackbarShow({
      type: SnackbarType.SUCCESS,
      children,
    });
  },

  snackbarShowWarning: (children: string) => {
    return get().snackbarShow({
      type: SnackbarType.WARNING,
      children,
    });
  },
}));

export default snackbarStore;
